import { Box, useTheme } from "@mui/material";
import { useParams } from "react-router-dom";

import { NavigationPage, PageHeader } from "@/shared/components";

import { Profile } from "./Profile";

export function User() {
  const theme = useTheme();
  const { userId } = useParams<string>();
  return (
    <NavigationPage title={`Roboto - Profile - ${userId}`}>
      <PageHeader>User Profile</PageHeader>

      <Box
        sx={{
          paddingTop: theme.spacing(2),
          paddingBottom: theme.spacing(2),
        }}
      >
        <Profile userId={userId} />
      </Box>
    </NavigationPage>
  );
}
